import React, { Fragment } from "react";
import AdvancedManagementCardWithInput from "./AdvancedManagementCardWithInput";
import UploadFile from "../../../../shared/UploadFile/UploadFile";
import { CSSTransition } from "react-transition-group";
import Card from "../../../../shared/Card/Card";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";

const AdvancedManagementDocumentsScannedStatement = ({
	ifShow,
	onSave,
	onChange,
	setFrontAndBack,
	isFrontAndBack,
	documents,
	onCancel,
	checkDocuments
} = props) => {
	return (
		<>
			<Card className="advanced-management-send-documents__card" withoutMargin>
				<h4>Envio de documentos digitalizados</h4>
				<p>
					Nesta etapa, você deverá digitalizar e fazer upload dos documentos necessários para
					solicitar a vinculação da sua conta. Os arquivos devem estar nos formatos jpg ou png e ter
					até 5 MB cada um.
				</p>
				<p>
					Você tem até 48 horas para concluir esta etapa. Depois desse prazo, a indicação irá se
					expirar e terá que ser iniciada novamente.
				</p>
				<p>
					Ah, após a primeira aprovação de vínculo, você precisará enviar apenas a Declaração de
					Vínculo para cada participante, combinado?
				</p>
				<div className="advanced-management-send-documents__card__uploads-files">
					<div className="advanced-management-send-documents__card__uploads-files--line">
						<div className="advanced-management-send-documents__card__uploads-files--line--upload">
							<UploadFile
								label={<strong>Documento com foto (frente)</strong>}
								onChange={event => onChange("idFront", event)}
								accept="image/png,image/jpeg"
							/>
						</div>
						<div className="advanced-management-send-documents__card__uploads-files--line--text">
							<Checkbox
								options={[
									{
										textStyle:
											"advanced-management-send-documents__card__uploads-files--line--text-checkbox",
										label: "O arquivo tem frente e verso do documento",
										value: "frontAndBack",
										checked: isFrontAndBack
									}
								]}
								onChange={event => setFrontAndBack(event)}
							/>
						</div>
					</div>

					{!isFrontAndBack && (
						<div className="advanced-management-send-documents__card__uploads-files--line">
							<div className="advanced-management-send-documents__card__uploads-files--line--upload">
								<UploadFile
									label={<strong>Documento com foto (verso)</strong>}
									onChange={event => onChange("idBack", event)}
									accept="image/png,image/jpeg"
									disabled={!documents.idFront}
								/>
							</div>
							<div className="advanced-management-send-documents__card__uploads-files--line--text-backDocument">
								<p>Confira se a imagem digitalizada está nítida.</p>
							</div>
						</div>
					)}

					<div className="advanced-management-send-documents__card__uploads-files--line">
						<div className="advanced-management-send-documents__card__uploads-files--line--upload">
							<UploadFile
								label={<strong>Selfie com documento</strong>}
								onChange={event => onChange("selfie", event)}
								accept="image/png,image/jpeg"
								disabled={!documents.idBack && !isFrontAndBack}
							/>
						</div>
						<div className="advanced-management-send-documents__card__uploads-files--line--text-lastDocuments">
							<p>
								Faça uma foto sua segurando, ao lado do rosto, a parte da frente do documento de
								identificação.
							</p>
						</div>
					</div>

					<div className="advanced-management-send-documents__card__uploads-files--line">
						<div className="advanced-management-send-documents__card__uploads-files--line--upload">
							<UploadFile
								label={<strong>Declaração de Vínculo assinada</strong>}
								onChange={event => onChange("declaration", event)}
								accept="image/png,image/jpeg"
								disabled={!documents.selfie}
							/>
						</div>
						<div className="advanced-management-send-documents__card__uploads-files--line--text-lastDocuments">
							<p>
								Atenção! A assinatura da declaração precisa ser exatamente igual a do documento
								enviado por você.
							</p>
						</div>
					</div>
				</div>
				<hr />
				<p>
					Você pode escanear ou fotografar seus documentos, combinado? Lembre que as imagens não
					podem estar cortadas e os textos devem estar totalmente legíveis.
				</p>
			</Card>
			<div className="advanced-management-send-documents__actions">
				<Button onClick={() => onCancel()} className="btn-gray-lg-label btn--without-bold">
					Cancelar
				</Button>
				<Button disabled={checkDocuments()} onClick={() => onSave()} className="btn-primary-lg">
					Avançar
				</Button>
			</div>
		</>
	);
};

export default AdvancedManagementDocumentsScannedStatement;
